import type { SearchHistory } from '@frontend/libs/stores/useSearchStore'

import { parseHtml } from '@frontend/libs/utils'
import { Button } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { Link } from 'react-router-dom'

export interface SearchHistoryListProps {
  onClearSearchHistory: () => void
  searchHistories: SearchHistory[]
}

export function SearchHistoryList({
  onClearSearchHistory,
  searchHistories,
}: SearchHistoryListProps) {
  if (!searchHistories) return <></>

  return (
    <div>
      <div className="mb-4 flex select-none items-center gap-1 border-b border-primary/20 pb-2">
        <h4 className="font-medium uppercase">
          {__('Your Search history', 'asavagroup')}
        </h4>
        <Button
          className="h-auto max-h-full py-3 text-center uppercase underline"
          onPress={onClearSearchHistory}
          variant="light"
        >
          {__('Clear', 'asavagroup')}
        </Button>
      </div>

      {searchHistories.map((item) => (
        <Button
          as={Link}
          className="block h-auto max-h-full py-2 text-left"
          fullWidth
          key={item.post_id}
          to={item.url}
          variant="light"
        >
          <div className="flex items-center gap-4 uppercase">
            {parseHtml(item.thumb_html || '')}
            <span className="block">{item.value}</span>
          </div>
        </Button>
      ))}
    </div>
  )
}

export default SearchHistoryList
